<template>
  <canvas class="three-canvas" ref="threeCanvas"></canvas>
</template>

<script>
import Platform from '@/platform'
import HopeConceptStone from '@/atoms/HopeConceptStone'
import HopeStoneTexture from '@/atoms/HopeStoneTexture'
import RAF from '@/utils/RAF'
import applyToonLighting from '@/utils/applyToonLighting'

/* global THREE */

export default {
  name: 'StoneCanvas',

  // mixins: [Viewport],

  props: {
    width: {
      type: Number,
      required: true,
      default: 100
    },
    height: {
      type: Number,
      required: true,
      default: 100
    },
    // doScreenshot: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    // },
    concept: {
      type: Object,
      required: true,
      default: {
        id: 1,
        category: 1,
        activity: 0.1,
        label: 'social justice'
      }
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    overrideActivity: {
      type: Object,
      required: false,
      default () {
        return {
          value: -1,
          trend: 1
        }
      }
    }
  },

  data: function () {
    return {
    }
  },

  mounted: function () {
    if (!Platform.prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true
        // preserveDrawingBuffer: true
      })
      this._clock = new THREE.Clock()
      this._renderer.toneMapping = THREE.LinearToneMapping
      this._renderer.setClearColor(0xffffff, 0)
      this._renderer.setPixelRatio(window.devicePixelRatio)
      this._renderer.setSize(this.width, this.height)

      this._scene = new THREE.Scene()

      this._camera = new THREE.PerspectiveCamera(50, this.width / this.height, 0.001, 10)
      this._camera.position.set(0, 0, 0.5)

      this._directionalLight = new THREE.DirectionalLight()
      this._directionalLight.position.set(0, 5, 5)
      this._scene.add(this._directionalLight)

      this.updateStoneConcept(this.concept)
      RAF.add(this.render)
    }
  },

  beforeDestroy: function () {
    this._scene.traverse(this.destroySceneChildren)
    this._renderer.dispose()
    this._renderer.forceContextLoss()
    // this._renderer.context.getExtension('WEBGL_lose_context').loseContext()
    // console.log('dispose')
    RAF.remove(this.render)
  },

  methods: {
    destroySceneChildren: function (value) {
      if (typeof value.destroy === 'function') {
        // console.log('destroy')
        value.destroy()
      } else {
        if (value.geometry) {
          value.geometry.dispose()
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose()
          }
          value.material.dispose()
        }
      }
    },

    updateStoneConcept: function (concept) {
      if (this._conceptStone) {
        if (this.isDifferent(this._conceptStone.config, concept)) {
          this._scene.remove(this._conceptStone)
          this._conceptStone.destroy()
        } else {
          return
        }
      }
      if (concept) {
        let copyConcept = Object.assign({}, concept)
        copyConcept.importance = 0.1
        if (this.overrideActivity.value !== -1) {
          copyConcept.activity = this.overrideActivity.value
          copyConcept.trend = this.overrideActivity.trend
        }

        // let cat = GoogleHopeService.getConceptCategory(copyConcept)
        this._conceptStone = new HopeConceptStone(copyConcept, new THREE.MeshToonMaterial({
          specular: new THREE.Color(0x000000),
          shininess: 0,
          map: new HopeStoneTexture(copyConcept.categoryObject.color, 1),
          transparent: false
        }))
        this._conceptStone.material.onBeforeCompile = applyToonLighting
        this._conceptStone.setVisible(true)
        this._conceptStone.castShadow = false
        this._scene.add(this._conceptStone)
        this._ticksBeforeScreenShot = 0
      }
    },

    isDifferent: function (a, b) {
      return a.id !== b.id || a.activity !== b.activity || a.category !== b.category || a.label !== b.label
    },

    render: function () {
      if (!this.active) return

      let delta = this._clock.getDelta()
      if (this._conceptStone) {
        this._conceptStone.update(null, delta, true)

        // if (this.doScreenshot) {
        //   this._ticksBeforeScreenShot++
        //   if (this._ticksBeforeScreenShot === 60) {
        //     this.$emit('screenshot', this._renderer.domElement.toDataURL('image/png'))
        //   }
        // }
      }
      this._renderer.render(this._scene, this._camera, null, true)
    },
    onResize: function () {
      if (this._renderer) {
        this._renderer.setPixelRatio(window.devicePixelRatio)
        this._renderer.setSize(this.width, this.height)
      }

      if (this._camera) {
        this._camera.aspect = this.width / this.height
        this._camera.updateProjectionMatrix()
      }
    }
  },
  watch: {
    overrideActivity: {
      depp: true,
      handler: function (value) {
        this._conceptStone.config.activity = value.value
        this._conceptStone.config.trend = value.trend
        this._conceptStone.config = this._conceptStone.config
      }
    },
    concept: function (value) {
      this.updateStoneConcept(value)
    },
    width: function (value) {
      setTimeout(this.onResize.bind(this))
    },
    height: function (value) {
      setTimeout(this.onResize.bind(this))
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';


</style>



// WEBPACK FOOTER //
// src/atoms/StoneCanvas.vue